export default {"src":"/_next/static/image/src/images/our-food/white-rice.e3685e211345a50ba55ff295df95c831.svg","height":32,"width":72};